/** 全角数字（０-９）を半角に。長音・全角ハイフン等は半角ハイフンに統一 */
const HYPHEN_LIKE_CHARS = /[\u30FC\uFF0D\u2212\u2010\u2011\u2012\u2013\u2014\u2015]/g
const FULLWIDTH_DIGITS = /[\uFF10-\uFF19]/g

export function normalizePhonePostalInput(value) {
  if (value === undefined || value === null) return value
  return String(value)
    .replace(HYPHEN_LIKE_CHARS, '-')
    .replace(FULLWIDTH_DIGITS, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0))
}

/** 郵便番号: 上記正規化のあと、ハイフンが無く数字が7桁なら 123-4567 に整形 */
export function normalizePostalCodeInput(value) {
  const base = normalizePhonePostalInput(value)
  if (base === undefined || base === null) return base
  const s = String(base)
  if (s.includes('-')) return s
  const digits = s.replace(/\D/g, '')
  if (digits.length === 7) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`
  }
  return s
}
